"use client";

import { ArrowRight, BadgeCheck, Eye, Image as ImageIcon } from "lucide-react";
import { Link } from "@/components/common/Link";
const PARTNER_IMAGE = "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1674648/img/partner-course-coast.png";
const benefits = [{
  icon: Eye,
  title: "Reach qualified golfers",
  text: "Increase visibility with travellers actively planning golf trips across Asia."
}, {
  icon: ImageIcon,
  title: "Present your course beautifully",
  text: "Showcase your course through premium imagery, useful details and destination context."
}, {
  icon: BadgeCheck,
  title: "Build trust and enquiries",
  text: "Give golfers clearer information and direct pathways to contact or book."
}];
export default function BespokeElegance() {
  return <section id="home-partner-courses" data-section-id="231882" data-home-section="partner-courses" aria-label="Partner With TeeListClub" className="w-full border-t border-[#DED3BF] bg-[#EFE9DD] px-5 py-0 !h-[450px] md:px-8 lg:px-12" style={{
    fontFamily: '"Raleway", Arial, sans-serif'
  }}>
      <div className="mx-auto w-full max-w-[1480px]">
        <div className={["relative overflow-hidden", "rounded-[16px]", "border border-[#D8C69B]", "bg-[#FFFDF7]", "shadow-[0_10px_28px_rgba(7,63,49,0.08)]"].join(" ")}>
          <div className={["grid grid-cols-1", "lg:min-h-[430px]", "lg:grid-cols-[43%_35%_22%]"].join(" ")}>
            {/* Main partnership message */}
            <div className="relative z-10 flex min-h-[410px] flex-col justify-center px-8 py-12 !opacity-[1] !bg-[rgba(7,63,49,1)] sm:px-10 lg:px-14 lg:py-14 xl:px-16">
              <p className={["text-[11px] font-bold uppercase", "tracking-[0.19em]", "text-[#BFFF00]"].join(" ")}>
                For Golf Courses
              </p>

              <h2 className={["mt-4 max-w-[590px]", "text-[40px] font-medium", "leading-[1.05]", "tracking-[-0.03em]", "text-[#FFFDF7]", "sm:text-[46px]", "xl:text-[51px]"].join(" ")} style={{
              fontFamily: '"Playfair Display", Georgia, "Times New Roman", serif'
            }}>
                Partner with TeeListClub.
              </h2>

              <p className={["mt-5 max-w-[530px]", "text-[15px] font-medium", "leading-[1.7]", "text-[#FFFDF7]/84", "lg:text-[16px]"].join(" ")}>
                Position your course within a premium golf discovery and
                course-intelligence platform for travellers across Asia.
              </p>

              <div className={["mt-8 flex flex-col gap-4", "sm:flex-row sm:items-center sm:gap-6"].join(" ")}>
                <Link to="/teelistclub-landing/" className={["group inline-flex", "h-[54px] min-w-[205px]", "items-center justify-between gap-5", "rounded-[9px]", "bg-[#BFFF00]", "px-5 pl-6", "text-[11px] font-bold uppercase", "tracking-[0.08em]", "leading-none", "text-[#073F31]", "no-underline", "shadow-[0_9px_25px_rgba(0,0,0,0.18)]", "transition-all duration-300", "hover:-translate-y-[2px]", "hover:bg-[#CCFF38]"].join(" ")}>
                  <span>Explore Partnership</span>

                  <span className={["flex size-8 shrink-0", "items-center justify-center", "rounded-full", "bg-[#073F31]/10", "transition-all duration-300", "group-hover:bg-[#073F31]", "group-hover:text-[#BFFF00]"].join(" ")}>
                    <ArrowRight className="size-4" strokeWidth={1.8} aria-hidden="true" />
                  </span>
                </Link>

                <Link to="/teelistclub-landing/#partner-enquiry" className={["group inline-flex min-h-[44px]", "items-center gap-2", "text-[12px] font-semibold", "text-[#D8C69B]", "no-underline", "transition-colors duration-200", "hover:text-[#BFFF00]"].join(" ")}>
                  <span className={["border-b border-[#D8C69B]/55", "pb-1", "group-hover:border-[#BFFF00]/70"].join(" ")}>
                    Submit or Verify Your Course
                  </span>

                  <ArrowRight className={["size-4", "transition-transform duration-200", "group-hover:translate-x-1"].join(" ")} strokeWidth={1.7} aria-hidden="true" />
                </Link>
              </div>
            </div>

            {/* Course image */}
            <div className="relative min-h-[340px] overflow-hidden lg:min-h-[430px]">
              <img src={PARTNER_IMAGE} alt="Premium coastal golf course in Asia" loading="lazy" decoding="async" className="absolute inset-0 w-full object-cover object-center !h-[430px]" />

              <div aria-hidden="true" className={["pointer-events-none absolute inset-y-0 left-0", "hidden w-[24%]", "bg-gradient-to-r", "from-[#073F31]/70", "via-[#073F31]/22", "to-transparent", "lg:block"].join(" ")} />

              <div aria-hidden="true" className={["pointer-events-none absolute inset-x-0 bottom-0", "h-[22%]", "bg-gradient-to-t", "from-[#073F31]/12", "to-transparent"].join(" ")} />
            </div>

            {/* Partnership benefits */}
            <aside className={["flex flex-col justify-center", "bg-[#FFFDF7]", "px-7 py-8", "sm:px-9", "lg:px-7 lg:py-7", "xl:px-9"].join(" ")}>
              {benefits.map((benefit, index) => {
              const Icon = benefit.icon;
              return <div key={benefit.title} className={["flex min-h-[116px]", "items-start gap-4 py-5", index > 0 ? "border-t border-[#DED3BF]" : ""].join(" ")}>
                    <div className={["mt-0.5 flex size-[46px]", "shrink-0 items-center justify-center", "rounded-[10px]", "border border-[#B79A5F]", "bg-[#F7F3E9]", "text-[#073F31]"].join(" ")}>
                      <Icon className="size-[20px]" strokeWidth={1.5} aria-hidden="true" />
                    </div>

                    <div className="min-w-0">
                      <h3 className={["text-[14px] font-semibold", "leading-[1.35]", "text-[#073F31]"].join(" ")} style={{
                    fontFamily: '"Playfair Display", Georgia, "Times New Roman", serif'
                  }}>
                        {benefit.title}
                      </h3>

                      <p className={["mt-2 text-[12px] font-medium", "leading-[1.55]", "text-[#596B63]"].join(" ")}>
                        {benefit.text}
                      </p>
                    </div>
                  </div>;
            })}
            </aside>
          </div>

          {/* Centre emblem */}
          <div aria-hidden="true" className={["pointer-events-none absolute", "left-[43%] top-1/2 z-20", "hidden size-[76px]", "-translate-x-1/2 -translate-y-1/2", "items-center justify-center", "rounded-[12px]", "border border-[#B79A5F]", "bg-[#073F31]", "text-[#D8C69B]", "shadow-[0_10px_24px_rgba(0,0,0,0.17)]", "lg:flex"].join(" ")}>
            <span className="text-[35px] leading-none" style={{
            fontFamily: '"Playfair Display", Georgia, "Times New Roman", serif'
          }}>
              T
            </span>
          </div>
        </div>
      </div>
    </section>;
}